export default __webpack_public_path__ + "images/0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e.png";